<div class="container">
  <div class="landing">
    <section class="hero" id="hero">
      <div class="hero__image">
        <img src="../../../../assets/integrations/olx.svg" alt="Power OLX">
      </div>
      <div class="hero__content">
        <h1 class="hero__title">{{ 'olx_page.hero_title' | translate }}</h1>
        <p class="hero__subtitle">{{ 'olx_page.hero_subtitle' | translate }}</p>
        <a [href]="environment.login_url">
          <app-button [title]="'olx_page.hero_button' | translate"></app-button>
        </a>
      </div>
      <div class="hero__scroll" (click)="scrollTo('features')">
        <app-icon>expand_more</app-icon>
      </div>
    </section>

    <div class="section-container" id="features">
      <h2 class="section-title">{{ 'olx_page.about_title' | translate }}</h2>
      <p class="section-description">{{ 'olx_page.about_description' | translate }}</p>
      <ul class="features-list">
        <li>{{ 'olx_page.about_feature_1' | translate }}</li>
        <li>{{ 'olx_page.about_feature_2' | translate }}</li>
        <li>{{ 'olx_page.about_feature_3' | translate }}</li>
        <li>{{ 'olx_page.about_feature_4' | translate }}</li>
        <li>{{ 'olx_page.about_feature_5' | translate }}</li>
        <li>{{ 'olx_page.about_feature_6' | translate }}</li>
        <li>{{ 'olx_page.about_feature_7' | translate }}</li>
        <li>{{ 'olx_page.about_feature_8' | translate }}</li>
      </ul>
    </div>

    <div class="section-container">
      <h2 class="section-title">{{ 'olx_page.assistant_title' | translate }}</h2>
      <p class="section-description">{{ 'olx_page.assistant_description' | translate }}</p>
      <ul class="features-list">
        <li>{{ 'olx_page.assistant_feature_1' | translate }}</li>
        <li>{{ 'olx_page.assistant_feature_2' | translate }}</li>
        <li>{{ 'olx_page.assistant_feature_3' | translate }}</li>
      </ul>
    </div>

    <div class="section-container">
      <h2 class="section-title">{{ 'olx_page.planner_title' | translate }}</h2>
      <p class="section-description">{{ 'olx_page.planner_description' | translate }}</p>
      <div class="screenshot">
        <img src="../../../../assets/img/powerOlx.png" alt="Інтерфейс планування">
      </div>
    </div>

    <app-interface-for-all></app-interface-for-all>

    <div class="section-container">
      <h2 class="section-title">{{ 'olx_page.audience_title' | translate }}</h2>
      <ul class="audience-list">
        <li>{{ 'olx_page.audience_1' | translate }}</li>
        <li>{{ 'olx_page.audience_2' | translate }}</li>
        <li>{{ 'olx_page.audience_3' | translate }}</li>
        <li>{{ 'olx_page.audience_4' | translate }}</li>
        <li>{{ 'olx_page.audience_5' | translate }}</li>
      </ul>
    </div>

    <app-advantages></app-advantages>

    <app-reviews></app-reviews>

    <div class="section-container">
      <h2 class="section-title">{{ 'olx_page.faq_title' | translate }}</h2>
      <div class="faq-list">
        <div class="faq-item">
          <h3 class="faq-question">{{ 'olx_page.faq_1_question' | translate }}</h3>
          <p class="faq-answer">{{ 'olx_page.faq_1_answer' | translate }}</p>
        </div>
        <div class="faq-item">
          <h3 class="faq-question">{{ 'olx_page.faq_2_question' | translate }}</h3>
          <p class="faq-answer">{{ 'olx_page.faq_2_answer' | translate }}</p>
        </div>
        <div class="faq-item">
          <h3 class="faq-question">{{ 'olx_page.faq_3_question' | translate }}</h3>
          <p class="faq-answer">{{ 'olx_page.faq_3_answer' | translate }}</p>
        </div>
        <div class="faq-item">
          <h3 class="faq-question">{{ 'olx_page.faq_4_question' | translate }}</h3>
          <p class="faq-answer">{{ 'olx_page.faq_4_answer' | translate }}</p>
        </div>
      </div>
    </div>

    <div class="section-container">
      <h2 class="section-title">{{ 'olx_page.cta_title' | translate }}</h2>
      <a [href]="environment.login_url">
        <app-button [title]="'olx_page.cta_button' | translate" [isOutline]="true"></app-button>
      </a>
      <p class="cta-subtext">{{ 'olx_page.cta_subtext' | translate }}</p>
    </div>

    <app-integration-review
      [youtubeReviewLink]="'https://www.youtube.com/embed/P8z__xwMo18'"
      [youtubeReviewTitle]="'olx.title' | translate"
    ></app-integration-review>
  </div>
</div>
